<section class="pd-section">
  <div class="container">

    <!-- Section Header -->
    <div class="pd-header">
      <div class="pd-header-spacer"></div>

      <div class="pd-title-center">
        <span class="pd-label">Featured Items</span>
        <div class="pd-title-wrap">
          <span class="pd-line"></span>
          <i class='bx bxs-dish'></i>
          <h2 class="pd-title">Customer <span>Favorites</span></h2>
          <i class='bx bxs-dish'></i>
          <span class="pd-line"></span>
        </div>
        <p class="pd-subtitle">Handcrafted with premium ingredients — experience authentic flavors delivered fresh.</p>
      </div>

      <div class="pd-header-action pd-header-action-desktop">
        <a routerLink="/product-menu" class="pd-btn">All Menu</a>
      </div>
    </div>

    <!-- 4-Column Grid -->
    <div class="pd-grid">
      <div
        class="pd-card"
        *ngFor="let item of singleProductsBox"
      >
        
        <div class="pd-img-wrap">
          <img [src]="item.mainImg" [alt]="item.title" loading="lazy">
          <span class="pd-badge">{{ item.badge || 'Best Seller' }}</span>
          <!-- <button
            class="pd-fav"
            [class.active]="item.isFav"
            (click)="toggleFav(item)"
            aria-label="Add to favorites"
          >
            <i class='bx bxs-heart'></i>
          </button> -->
        </div>

       
        <div class="pd-body" [class.no-desc]="!item.description">
          <h3 class="pd-name">{{ item.title }}</h3>
          <p class="pd-weight" *ngIf="item.description">{{ item.description }}</p>

          <div class="pd-footer">
            <div class="pd-price-wrap">
              <span class="pd-price">{{ item.newPrice }}</span>
              <span class="pd-old-price" *ngIf="item.oldPrice">{{ item.oldPrice }}</span>
              <span class="pd-discount" *ngIf="item.discount">{{ item.discount }}</span>
            </div>

            <div class="pd-right">
              <div class="pd-qty-control" *ngIf="item.inCart">
                <button
                  class="pd-qty-btn pd-qty-minus"
                  (click)="decreaseQuantity(item)"
                  [disabled]="item.quantity <= 1"
                  aria-label="Decrease quantity"
                >
                  <i class='bx bx-minus'></i>
                </button>
                <span class="pd-qty-value">{{ item.quantity }}</span>
                <button
                  class="pd-qty-btn pd-qty-plus"
                  (click)="increaseQuantity(item)"
                  aria-label="Increase quantity"
                >
                  <i class='bx bx-plus'></i>
                </button>
              </div>
              <button
                class="pd-add-btn"
                [class.added]="item.justAdded"
                [class.in-cart]="item.inCart"
                (click)="addToCartAnimated(item)"
                *ngIf="!item.inCart"
                aria-label="Add to cart"
              >
                  <i class='bx' [ngClass]="item.justAdded ? 'bx-check' : 'bx-plus'"></i>
              </button>
            </div>
          </div>
        </div>

      </div>
    </div>
    <!-- End Grid -->

    <!-- Mobile View All Button -->
    <div class="pd-header-action pd-header-action-mobile">
      <a routerLink="/product-menu" class="pd-btn">All Menu</a>
    </div>

  </div>
</section>